import React, {useState} from 'react';
import { Modal, Button } from 'react-bootstrap';
import classes from './style.module.css'

const LeagueDetailPopup = props => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const getFullDomain = () => {
    const protocol = window.location.protocol;
    const domain = window.location.hostname;
    const port = window.location.port;
    var full = `${protocol}//${domain}:${port? port : ""}`;
    return full;
  }
  return (
    <>
      <a class="leagueCss" variant="primary" onClick={handleShow}>
         &nbsp;&nbsp;(League Table)
      </a>
      <Modal show={show} dialogClassName="modal-90w" onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> {props.league}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <iframe src={`${getFullDomain()}/popup.html?leagueId=${props.apiLeageId}&season=2021`} frameborder="0"
         style={{overflow:'hidden', height:'100%', width:'100%'}} ></iframe>
           
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default LeagueDetailPopup;